import React, { useState } from 'react';
import CumpleNoticias from './CumpleNoticias';
import Noticias from './Noticias';
import NuevaNoticia from './NuevaNoticia';
import VerificarPermisos from '../Tools/VerificarPermisos';
import Modal from 'react-bootstrap/Modal';
function PrincipalSocial() {
    const [pagina,setPagina] =useState(3);
    const [paginaAnt,setPaginaAnt] = useState(0);
    const [enableButtons,setEnableButtons] = useState(false);  
    const [modalAdd,setModalAdd] =useState(false);
    const desablebuttonActivo=(cambio)=>{
        if(cambio===pagina){
            setEnableButtons(false);
        }else{
            setEnableButtons(true)
        }
    }
    const cerrarModalAdd = ()=>{
        setModalAdd(false);
        setPagina(paginaAnt);
    }
    return (
        <div className=''>
            {pagina===0&&
                <Noticias setEnable={setEnableButtons} tipo='D'/>
            }
            {pagina===1&&
                <CumpleNoticias setEnable={setEnableButtons}/>
            }
            {pagina===2&&
                <Noticias setEnable={setEnableButtons} tipo='M'/>
            }
            {pagina===3&&
                <Noticias setEnable={setEnableButtons} tipo='G'/>
            }
            {/*pagina===4&&
                <NuevaNoticia setEnable={setEnableButtons}/>*/
            }
            <div className='container-fluid px-auto floatBotones text-center bg-dark overflow-auto' style={{ bottom: '0%'}}>
                <div className='btn-group'>
                    <button className={pagina===0?"btn btn-sm btn-light bg-gradient mx-1":"btn btn-sm btn-dark bg-gradient mx-1"}
                        onClick={()=>{setPagina(0);desablebuttonActivo(0)}} disabled={enableButtons}>
                        <div className='container-fluid m-0 p-0 '>
                            <div className='text-center'>
                                <i className="fa-regular fa-newspaper fa-beat"></i>
                            </div>
                            <div className='text-center'>
                                <span className=''>Destacada</span>
                            </div>
                        </div>
                    </button>
                    <button className={pagina===3?"btn btn-sm btn-light bg-gradient mx-1":"btn btn-sm btn-dark bg-gradient mx-1"}
                        onClick={()=>{setPagina(3);desablebuttonActivo(3)}} disabled={enableButtons}>
                        <div className='container-fluid m-0 p-0 '>
                            <div className='text-center'>
                                <i className="fa-regular fa-newspaper fa-beat"></i>
                            </div>
                            <div className='text-center'>
                                <span className=''>Global</span>
                            </div>
                        </div>
                    </button>
                    <button className={pagina===1?"btn btn-sm btn-light bg-gradient mx-1":"btn btn-sm btn-dark bg-gradient mx-1"}
                        onClick={()=>{setPagina(1);desablebuttonActivo(1)}} disabled={enableButtons}>
                        <div className='container-fluid m-0 p-0'>
                            <div className='text-center'>
                                <i className="fa-solid fa-cake-candles fa-beat"></i>
                            </div>
                            <div className='text-center'>
                                <span className=''>Cumples</span>
                            </div>   
                        </div>
                    </button>
                    <button className={pagina===2?"btn btn-sm btn-light bg-gradient mx-1":"btn btn-sm btn-dark bg-gradient mx-1"}
                        onClick={()=>{setPagina(2);desablebuttonActivo(2)}} disabled={enableButtons}>
                        <div className='container-fluid m-0 p-0 '>
                            <div className='text-center'>
                                <i className="fa-solid fa-star fa-beat"></i>
                            </div>
                            <div className='text-center'>
                                <span className=''>Favoritos</span>
                            </div>   
                        </div>
                    </button>
                    {VerificarPermisos.validarPermiso('14')&&
                    <button className={pagina===4?"btn btn-sm btn-light bg-gradient mx-1":"btn btn-sm btn-dark bg-gradient mx-1"}
                        onClick={()=>{setPaginaAnt(pagina);setPagina(4);setModalAdd(true)}} disabled={enableButtons}>
                        <div className='container-fluid m-0 p-0 '>
                            <div className='text-center'>
                                <i className="fa-solid fa-circle-plus fa-beat"></i>
                            </div>
                            <div className='text-center'>
                                <span className=''>Nuevo</span>
                            </div>   
                        </div>
                    </button>}
                </div>
            </div>
            <Modal show={modalAdd} onHide={cerrarModalAdd}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Nueva Noticia</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <NuevaNoticia cerrarModalAdd={cerrarModalAdd}/>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PrincipalSocial
